<template>
    <div ref="modal" class="modal fade" data-backdrop="static" data-keyboard="false" role="dialog">
        <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">
                        Upload de arquivo
                    </h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="text-center">
                        <input ref="file" type="file" accept=".xlsx, .xls, image/*, .doc, .docx, .ppt, .pptx, .txt, .pdf">
                    </div>
                    <div class="progress w-100 mt-2" v-if="uploading">
                        <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" :style="{ width : progress + '%'}">
                            {{ progress.toFixed(2) + "%" }}
                        </div>
                    </div>
                    <div v-if="file === null" class="alert alert-info text-left">Tipos de arquivo aceitos: Excel, Word, PDF, PowerPoint, Arquivo de Texto, Imagens (gif, png, jpg, etc).<br>Tamanho máximo do arquivo: 5mb</div>
                    <div style="font-weight: 500; color: #ff0000">Upload de arquivos somente para conferência. Não pode ser usado para substituir arquivos de pedidos.</div>
                </div>
                <div class="modal-footer">
                    <div class="w-100">
                        <div class="float-right">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">cancelar</button>
                            <button type="button" class="btn btn-success" @click="upload" :disabled="uploading || file === null">enviar</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "messenger-upload",
        props: ['chat_id'],
        data : function(){
            return {
                file : null,
                uploading : false,
                progress : 0
            };
        },
        mounted : function () {
            if ($.ezdz === undefined)
                return;
            var $vm = this;
            $(this.$refs.file).ezdz({
                validators: {
                    maxSize: ((5 * 1024 ) * 1024)
                },
                accept : function(file){
                    $vm.file = file;
                },
                reject : function(){
                    $vm.file = null;
                }
            });
        },
        methods : {
            Reset : function(){
                this.file = null;
                this.uploading = false;
                this.progress = 0;
                $(this.$refs.file).ezdz('preview', null);
            },
            Open : function(){
                this.Reset();
                $(this.$refs.modal).modal('show');
            },
            Upload : function(){
                var $vm = this;
                if ($vm.file === null)
                    return;

                var fdata = new FormData();
                fdata.append('file', $vm.file);

                var config = {
                    onUploadProgress: function(progressEvent) {
                        $vm.progress = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
                    }
                };
                $vm.uploading = true;
                axios.post('/admin/messenger/upload/' + $vm.chat_id, fdata, config).then(function (response) {
                    if(response.data.sucesso){
                        $vm.$emit('upload');
                        $vm.Close();
                    }
                    else{
                        alert('Ocorreu um erro no upload.');
                    }
                }).catch(function () {

                }).then(function () {
                    $vm.uploading = false;
                });
            },
            Close : function(){
                this.Reset();
                $(this.$refs.modal).modal('hide');
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/loja/vue-components/messenger-upload.vue